// Mirrors the API's ChangeLogTarget enum (AuditEntityRegistry.cs) — the entity/scope a ChangeLog query concerns.
export enum ChangeLogTarget {
  User = 'User',
  Persona = 'Persona',
  Audit = 'Audit',
  Training = 'Training',
  StockCount = 'StockCount',
  Invoice = 'Invoice',
  Transfer = 'Transfer',
  Waste = 'Waste',
}
